var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgG2Logo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 216 216",
    style: {
      enableBackground: "new 0 0 216 216"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0492D;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 108,
    cy: 108,
    r: 108
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M154.74,82.73H136.3c0.5-2.9,2.28-4.51,5.91-6.35l3.4-1.73c6.07-3.12,9.3-6.63,9.3-12.37 c0-3.62-1.39-6.46-4.18-8.53c-2.73-2.06-6.07-3.06-9.92-3.06c-3.07,0-5.85,0.78-8.41,2.4c-2.51,1.56-4.4,3.57-5.57,6.07l5.35,5.35 c2.06-4.18,5.07-6.24,9.03-6.24c3.34,0,5.4,1.73,5.4,4.12c0,2.01-1,3.68-4.85,5.63l-2.17,1.06c-4.74,2.4-8.02,5.13-9.92,8.25 c-1.89,3.06-2.84,7.02-2.84,11.76v1.28h27.92V82.73z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "152.28,99.18 121.74,99.18 106.47,125.63 137.01,125.63 152.28,152.08 167.55,125.63  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.1,143.27c-19.45,0-35.27-15.82-35.27-35.27s15.82-35.27,35.27-35.27l12.07-25.27 c-3.9-0.77-7.94-1.18-12.07-1.18c-34.08,0-61.71,27.63-61.71,61.71s27.63,61.71,61.71,61.71c13.59,0,26.15-4.4,36.35-11.84 l-13.37-23.16C125.9,140.04,117.87,143.27,109.1,143.27z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgG2Logo);
export default __webpack_public_path__ + "../static/product-reviews/assets/g2-logo.53606b9445072e7633b6ae7f84976d06.svg";
export { ForwardRef as ReactComponent };